export const en = {
    'add-button': 'Add',
    'exclude-phrases': 'Disable keywords without impressions',
    placeholder: 'Add keywords. Enter keywords separated by commas or the ( | ) operator'
};
